export * from './clientInfo.service';
import { ClientInfoService } from './clientInfo.service';
export * from './outboundMessages.service';
import { OutboundMessagesService } from './outboundMessages.service';
export const APIS = [ClientInfoService, OutboundMessagesService];
